import { render, staticRenderFns } from "./auto-repay.vue?vue&type=template&id=c1245468&scoped=true&"
import script from "./auto-repay.vue?vue&type=script&lang=js&"
export * from "./auto-repay.vue?vue&type=script&lang=js&"
import style0 from "./auto-repay.vue?vue&type=style&index=0&id=c1245468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1245468",
  null
  
)

export default component.exports